import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Badge from 'react-bootstrap/Badge';
import { func, string } from 'prop-types';
import Popover from 'react-bootstrap/Popover';

/**
 * Configuration
 */

const SHOW_DELAY = 250;
const HIDE_DELAY = 400;

export default function PriceFilterSuggestion({ onClick, matchedString }) {
    return (
        <OverlayTrigger
            overlay={
                <Popover
                    className={'price-filter-popover'}
                    placement={'bottom'}
                >
                    Accept suggestion?
                </Popover>
            }
            placement={'bottom'}
            delay={{
                show: SHOW_DELAY,
                hide: HIDE_DELAY
            }}
        >
            <Badge
                pill
                bg={'warning'}
                text={'dark'}
                style={{ cursor: 'pointer' }}
                onClick={onClick}
            >
                Price filter: {matchedString}
            </Badge>
        </OverlayTrigger>
    );
}

PriceFilterSuggestion.propTypes = {
    onClick: func,
    matchedString: string,
};
